<template>
  <t-modal
    v-model="isVisible"
    @closed="onModalClosed"
    name="edit-profile-image-modal"
  >
    <div>
      <h2 class="mb-3">Profile Image</h2>
      <ProfileImageCropper
        :image="image"
        v-on:onCancelEdit="handleCancelEdit"
        v-on:onApplyChanges="handleApplyChanges"
        v-if="editing"
      />
      <div v-else>
        <div class="flex relative mb-2 h-52 justify-center">
          <button
            class="w-52 bg-center bg-cover rounded-full br-10"
            :style="{backgroundImage: result.coordinates ? '' : 'url(' + image + ')'}"
            type="button"
            @click="onEditImage"
            title="Edit profile image"
          >
            <Preview :coordinates="result.coordinates" :height="208" :width="208" :image="result.image" v-if="result.coordinates" class="rouned-full" />
          </button>
        </div>
        <div class="flex items-center justify-between">
          <MediaUploadButton
            v-on:onFileUpload="onUploadMedia"
            text="Upload an Image"
          />
          <button
            class="primary-btn"
            type="button"
            @click.prevent="onSave"
          >Save Changes</button>
        </div>
      </div>
    </div>

  </t-modal>
</template>

<script>
import ProfileImageCropper from '../../Utils/ProfileImageCropper.vue';
import { Preview } from 'vue-advanced-cropper';
import MediaUploadButton from '../../Utils/MediaUploadButton.vue';
import 'vue-advanced-cropper/dist/style.css';
export default {
    props: ['modalVisible'],
    data() {
        return {
            isVisible: this.modalVisible,
            image: '/images/test-large-profile-image.jpeg',
            editing: false,
            result: {
                image: this.image,
                coordinates: null,
            }
        };
    },
    watch: {
        modalVisible() {
            if (this.isVisible !== this.modalVisible) {
                this.isVisible = this.modalVisible;
            }
        },
    },
    methods: {
        onModalClosed() {
            this.$emit('modalHidden');
        },
        onUploadMedia(event) {
            // TODO: open way to upload media
            const file = event.target.files[0];
        },
        onSave() {
            // TODO: add functionality of saving media
            this.isVisible = false;
            this.$emit('handleSubmit', this.image);
        },
        onEditImage() {
            this.editing = true;
        },
        handleApplyChanges(event) {
            // TODO: apply editing changes to image
            this.result.image = event.image;
            this.result.coordinates = event.coordinates;
            this.editing = false;
        },
        handleCancelEdit() {
            this.editing = false;
        },
    },
    components: {
        Preview,
        ProfileImageCropper,
        MediaUploadButton,
    },
};
</script>